export default __webpack_public_path__ + "static/media/no_photox.5a4938d1.svg";